import { getExceptionFromAxiosError } from '@/client/helpers';
import { MessageResponseModel } from '@/client/models';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import {
  HubspotErrorLogsRequest,
  HubspotErrorLogsResponse,
  HubspotErrorLogSummary,
  TrackHubspotEventRequest,
} from './types';

export const hubspotService = (client: AxiosInstance) => {
  const HUBSPOT_BASE_URL = 'integrations/hubspot';

  const sendSyncRequest = async (): Promise<MessageResponseModel> => {
    try {
      const result = await client.post<
        MessageResponseModel,
        AxiosResponse<MessageResponseModel>
      >(
        `/${HUBSPOT_BASE_URL}/link`,
        {},
        {
          withCredentials: true,
        },
      );

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const trackEvent = async (
    params: TrackHubspotEventRequest,
  ): Promise<MessageResponseModel> => {
    try {
      const result = await client.post<
        MessageResponseModel,
        AxiosResponse<MessageResponseModel>
      >(`/me/${HUBSPOT_BASE_URL}/events`, params, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const getErrorLogs = async (
    params: HubspotErrorLogsRequest,
  ): Promise<HubspotErrorLogsResponse> => {
    try {
      const { data } = await client.get<HubspotErrorLogsResponse>(
        `/${HUBSPOT_BASE_URL}/error-logs`,
        { params, withCredentials: true },
      );
      return data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const getErrorLogSummary = async (): Promise<HubspotErrorLogSummary> => {
    try {
      const { data } = await client.get<HubspotErrorLogSummary>(
        `/${HUBSPOT_BASE_URL}/error-logs/summary`,
        { withCredentials: true },
      );
      return data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const deleteErrorLog = async (id: string): Promise<void> => {
    try {
      await client.delete(`/${HUBSPOT_BASE_URL}/error-logs/${id}`, {
        withCredentials: true,
      });
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const hubspotNotifyUrl = () =>
    `${client.defaults.baseURL}${HUBSPOT_BASE_URL}/notify`;

  return {
    sendSyncRequest,
    trackEvent,
    hubspotNotifyUrl,
    getErrorLogs,
    getErrorLogSummary,
    deleteErrorLog,
  };
};
